<div
  class="avatar-container width-100"
  [fxLayoutAlign]="badge ? 'space-between center' : ''"
  [fxLayout]="badge ? 'row' : ''"
>
  <div class="role-tag" *ngIf="role && isMyProgramView">{{ role.name }}</div>

  <!-- --------------------------------------------------- Avatar Badge ------------------------------------------------------>

  <div *ngIf="badge" fxFlex="5%">
    <mat-label class="badge"> {{ badge }}</mat-label>
  </div>

  <!-- --------------------------------------------------- Avatar Pofile ------------------------------------------------------>

  <div *ngIf="profile && !isSurgeonSelection" fxLayoutAlign="fxLayoutAlign" [fxLayout]="displayMode" class="width-100">
    <!-- --------------------------------------------------- Profile Image  ------------------------------------------------------>

    <div
      *ngIf="showImage && !isPictureRight"
      [ngClass]="{ 'image-container': viewFlex && avatarBoxColor !== 'secondary' }"
    >
      <img
        (error)="onAvatarError()"
        [src]="picture"
        alt="avatar"
        [ngClass]="{
          'image-border': !specialty || (specialty && !specialty.isEmergency),
          image: !viewFlex,
          'small-avatar': smallAvatar,
          'tiny-avatar': tinyMode,
          bigImage: viewFlex,
          'big-row-image': isBigRow,
          'secondary-border': avatarBoxColor === 'secondary',
          'image-sidenav': isSideNav,
          'picture-border': pictureBorder,
        }"
      />
    </div>

    <!-- --------------------------------------------------- Profile Content (Name, Hours, Speciality) ------------------------------------------------------>

    <div
      [class.no-margin-left]="isColumn"
      [class.big-row]="isBigRow"
      [fxLayoutAlign]="isColumn ? 'start center' : 'start start'"
      [ngClass]="[
        isSideNav ? 'profile-name-sidenav' : 'a',
        isImportProfile ? 'profile-name-imp' : 'profile-name',
        nightMode ? 'dark-mode' : '',
      ]"
      class="data-container"
      fxFlex
      fxLayout="column"
    >
      @if (totalPresence) {
        <span
          class="total-presence"
          [class.presence-depassement]="profile.maxTime && totalPresenceHours && totalPresenceHours > profile.maxTime"
          >{{ totalPresence }}</span
        >
      }
      <div
        [fxLayoutAlign]="displayMode === 'row' ? 'space-between start' : fxLayoutAlign"
        [fxLayout]="displayMode"
        class="width-100 line-height-18px"
        [ngClass]="{ 'text-end': isPictureRight, 'only-name': programRecap }"
      >
        <!-- --------------------------------------------------- Content fullName ------------------------------------------------------>

        <mat-label
          *ngIf="!isBigScreen"
          [ngClass]="{
            'profile-name-sidenav': isSideNav,
            'hover-highlight': hoverHighlight,
            'non-overflow': smallName || tinyMode,
            'tiny-name': tinyMode,
          }"
          [class.text-center]="isColumn"
          [class.text-start]="!isColumn"
        >
          {{ fullName | titlecase }}</mat-label
        >

        <mat-label
          *ngIf="isBigScreen && !isMiddleScreen && getSize2Name(profile.firstName, profile.lastName) > 23"
          [ngClass]="{
            'profile-name-sidenav': isSideNav,
            'hover-highlight': hoverHighlight,
            'non-overflow': smallName || tinyMode || nameOverFlow,
            'tiny-name': tinyMode,
            'is-account-view': isAccountView,
          }"
          [class.text-center]="isColumn"
          [class.text-start]="!isColumn"
        >
          <!-- {{ (profile.firstName + ' ' + profile.lastName | titlecase).slice(0, 23) + '.' }}</mat-label> -->
          {{ (fullName | titlecase).slice(0, 23) + '.' }}</mat-label
        >

        <mat-label
          *ngIf="isBigScreen && !isMiddleScreen && getSize2Name(profile.firstName, profile.lastName) <= 23"
          [ngClass]="{
            'profile-name-sidenav': isSideNav,
            'hover-highlight': hoverHighlight,
            'non-overflow': smallName || tinyMode || nameOverFlow,
            'tiny-name': tinyMode,
            'is-account-view': isAccountView,
          }"
          [class.text-center]="isColumn"
          [class.text-start]="!isColumn"
        >
          <!-- {{ profile.firstName + ' ' + profile.lastName | titlecase }}</mat-label> -->
          {{ fullName | titlecase }}</mat-label
        >

        <mat-label
          *ngIf="
            isBigScreen &&
            isMiddleScreen &&
            profile &&
            profile.firstName &&
            profile.lastName &&
            getSize2Name(profile.firstName, profile.lastName) > 15
          "
          [ngClass]="{
            'profile-name-sidenav': isSideNav,
            'hover-highlight': hoverHighlight,
            'non-overflow': smallName || tinyMode,
            'tiny-name': tinyMode,
          }"
          [class.text-center]="isColumn"
          [class.text-start]="!isColumn"
        >
          <!-- {{ (profile.firstName + ' ' + profile.lastName | titlecase).slice(0, 13) + '.' }}</mat-label> -->
          {{ (fullName | titlecase).slice(0, 13) + '.' }}</mat-label
        >

        <mat-label
          *ngIf="
            isBigScreen &&
            isMiddleScreen &&
            profile &&
            profile.firstName &&
            profile.lastName &&
            getSize2Name(profile.firstName, profile.lastName) <= 15
          "
          [ngClass]="{
            'profile-name-sidenav': isSideNav,
            'hover-highlight': hoverHighlight,
            'non-overflow': smallName || tinyMode,
            'tiny-name': tinyMode,
          }"
          [class.text-center]="isColumn"
          [class.text-start]="!isColumn"
        >
          <!-- {{ profile.firstName + ' ' + profile.lastName | titlecase }}</mat-label> -->
          {{ fullName | titlecase }}</mat-label
        >

        <!-- --------------------------------------------------- Content Hours ------------------------------------------------------>
        <div *ngIf="showArrival" class="arrival-date">{{ getDateFormat(profile.startingDate) }}</div>

        <div class="display-inline" *ngIf="startTime && endTime">
          <div [fxLayout]="hoursLayout" class="hours-container">
            <div class="hour margin-bottom-2px">{{ formatUTCHours(startTime) }}</div>
            <div class="hour" *ngIf="hoursLayout === 'row'">&nbsp;-&nbsp;</div>
            <div class="hour">{{ formatUTCHours(endTime) }}</div>
          </div>
          <mat-label class="hour" *ngIf="isProfileInNurses && isGuard"> (Astreinte)</mat-label>
        </div>

        <!-- --------------------------------------------------- Profile status -------------------------------------------------------->
        <div class="display-inline" *ngIf="profile.isDesactivated">
          <mat-label class="hour"> (Désactivé)</mat-label>
        </div>
      </div>

      <!-- --------------------------------------------------- Content Speciality ------------------------------------------------------>
      <div
        [class.text-center]="isColumn"
        [class.text-start]="!isColumn"
        class="type width-100 non-overflow"
        [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty': tinyMode }"
      >
        <div
          *ngIf="!isBigScreen && !isMyProgramView"
          class="width-100"
          fxLayout="row"
          [ngClass]="{
            'only-name': programRecap && !isSmartPlanningDesign,
            'only-name-smart-planning-design': isSmartPlanningDesign,
            'dark-mode': nightMode,
          }"
        >
          <mat-label *ngIf="!hidePosition && (!showSeniority || !profile.seniority || profile.position === 'Iade')">{{
            profile.position ?? '' | toIADE
          }}</mat-label>
          <mat-label *ngIf="!hidePosition && showSeniority && profile.seniority && profile.position !== 'Iade'">{{
            getSeniority(profile.seniority)
          }}</mat-label>
          <div
            *ngIf="isSurgeon || !profile.isGarde"
            class="width-100"
            [ngClass]="{ 'non-overflow': smallSpecialty || tinyMode, 'tiny-specialty': tinyMode }"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <div
              *ngIf="isSurgeon && isSmartPlanningDesign && !hideSpecialty"
              [class.limit-specialty-without-hours]="!endTime && !startTime"
              [class.limit-specialty-with-hours]="(endTime || startTime) && !specialty?.diminutif"
              class="tooltip"
              [ngClass]="{ 'tooltip-enabled': showTooltip }"
            >
              {{ specialty?.diminutif ? specialty?.diminutif : truncateSpecialtyForNotBigScreen(specialty) }}
              <span *ngIf="showTooltip" class="tooltip-text">{{ specialty?.name }}</span>
            </div>

            <div
              *ngIf="
                profile.residency && !viewFlex && !hideResendency && !profile.isGarde && !onlyResidency && isBigScreen
              "
              [ngClass]="{
                'type-sidenav': isSideNav,
                'non-overflow': smallSpecialty || tinyMode,
                'tiny-specialty2': tinyMode,
                type: !tinyMode,
              }"
            >
              {{ '&nbsp;- ' + profile.residency }}
            </div>
            <div *ngIf="onlyResidency && isBigScreen" [ngClass]="{ 'tiny-specialty2': tinyMode, type: !tinyMode }">
              {{ profile.residency }}
            </div>
          </div>

          <mat-label
            *ngIf="profile.isGarde && !hidePosition"
            [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty2': tinyMode, type: !tinyMode }"
          >
            &nbsp;de garde
          </mat-label>
        </div>
        <div
          *ngIf="isBigScreen && !isMiddleScreen && !isAnnuaire"
          class="width-100"
          [ngClass]="{ 'only-name': programRecap, 'dark-mode': nightMode }"
          fxLayout="row"
        >
          <mat-label *ngIf="!hidePosition && (!showSeniority || !profile.seniority || profile.position === 'Iade')">{{
            truncatePositionForBigAndMiddleScreen(profile.position) | toIADE
          }}</mat-label>
          <mat-label *ngIf="!hidePosition && showSeniority && profile.seniority && profile.position !== 'Iade'">{{
            getSeniority(profile.seniority)
          }}</mat-label>
          <div
            *ngIf="isSurgeon || !profile.isGarde"
            class="width-100"
            [ngClass]="{ 'non-overflow': smallSpecialty || tinyMode, 'tiny-specialty': tinyMode }"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <div
              *ngIf="isSurgeon && isSmartPlanningDesign && !hideSpecialty"
              [class.limit-specialty-without-hours]="!endTime && !startTime"
              [class.limit-specialty-with-hours]="endTime || startTime"
              class="tooltip"
              [ngClass]="{ 'tooltip-enabled': showTooltip }"
            >
              {{ specialty?.name }}
              <span *ngIf="showTooltip" class="tooltip-text">{{ specialty?.name }}</span>
            </div>
            <div
              *ngIf="
                profile.residency && !viewFlex && !hideResendency && !profile.isGarde && !onlyResidency && isBigScreen
              "
              [ngClass]="{
                'type-sidenav': isSideNav,
                'non-overflow': smallSpecialty || tinyMode,
                'tiny-specialty2': tinyMode,
                type: !tinyMode,
                'dark-mode': nightMode,
              }"
            >
              {{ '&nbsp;- ' + profile.residency }}
            </div>
            <div *ngIf="onlyResidency && isBigScreen" [ngClass]="{ 'tiny-specialty2': tinyMode, type: !tinyMode }">
              {{ profile.residency }}
            </div>
          </div>

          <mat-label
            *ngIf="profile.isGarde && !hidePosition"
            [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty2': tinyMode, type: !tinyMode }"
          >
            &nbsp;de garde
          </mat-label>
        </div>
        <div *ngIf="isAnnuaire" class="width-100" [ngClass]="{ 'only-name': programRecap }" fxLayout="row">
          <mat-label *ngIf="!hidePosition">{{ profile.position ?? '' | toIADE }}</mat-label>
          <mat-label *ngIf="!hidePosition && showSeniority && profile.seniority"
            >&nbsp;{{ getSeniority(profile.seniority) }}</mat-label
          >
          <div
            *ngIf="isSurgeon || !profile.isGarde"
            class="width-100"
            [ngClass]="{ 'non-overflow': smallSpecialty || tinyMode, 'tiny-specialty': tinyMode }"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <div
              *ngIf="isSurgeon && isSmartPlanningDesign && !hideSpecialty"
              [class.limit-specialty-without-hours]="!endTime && !startTime"
              [class.limit-specialty-with-hours]="endTime || startTime"
              class="tooltip"
              [ngClass]="{ 'tooltip-enabled': showTooltip }"
            >
              {{ specialty?.name }}
              <span *ngIf="showTooltip" class="tooltip-text">{{ specialty?.name }}</span>
            </div>
            <div
              *ngIf="
                profile.residency && !viewFlex && !hideResendency && !profile.isGarde && !onlyResidency && isBigScreen
              "
              [ngClass]="{
                'type-sidenav': isSideNav,
                'non-overflow': smallSpecialty || tinyMode,
                'tiny-specialty2': tinyMode,
                type: !tinyMode,
              }"
            >
              {{ '&nbsp;- ' + profile.residency }}
            </div>
            <div *ngIf="onlyResidency && isBigScreen" [ngClass]="{ 'tiny-specialty2': tinyMode, type: !tinyMode }">
              {{ profile.residency }}
            </div>
          </div>

          <mat-label
            *ngIf="profile.isGarde && !hidePosition"
            [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty2': tinyMode, type: !tinyMode }"
          >
            &nbsp;de garde
          </mat-label>
        </div>
        <div
          *ngIf="isBigScreen && isMiddleScreen && !isMyProgramView"
          class="width-100"
          [ngClass]="{ 'only-name': programRecap }"
          fxLayout="row"
        >
          <mat-label *ngIf="!hidePosition && (!showSeniority || !profile.seniority)">{{
            truncatePositionForBigAndMiddleScreen(profile.position) | toIADE
          }}</mat-label>
          <mat-label *ngIf="!hidePosition && showSeniority && profile.seniority">{{
            getSeniority(profile.seniority)
          }}</mat-label>
          <div
            *ngIf="isSurgeon || !profile.isGarde"
            class="width-100"
            [ngClass]="{ 'non-overflow': smallSpecialty || tinyMode, 'tiny-specialty': tinyMode }"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <div
              *ngIf="isSurgeon && isSmartPlanningDesign && !hideSpecialty && specialty"
              [class.limit-specialty-without-hours]="!endTime && !startTime"
              [class.limit-specialty-with-hours]="endTime || startTime"
              class="tooltip"
              [ngClass]="{ 'tooltip-enabled': showTooltip }"
            >
              {{
                specialty.name.length! >= 13
                  ? specialty.diminutif
                    ? specialty.diminutif
                    : truncateSpecialtyForBigAndMiddleScreen(specialty)
                  : specialty.name
              }}
              <span *ngIf="showTooltip" class="tooltip-text">{{ specialty.name }}</span>
            </div>
            <div
              *ngIf="
                profile.residency && !viewFlex && !hideResendency && !profile.isGarde && !onlyResidency && isBigScreen
              "
              [ngClass]="{
                'type-sidenav': isSideNav,
                'non-overflow': smallSpecialty || tinyMode,
                'tiny-specialty2': tinyMode,
                type: !tinyMode,
              }"
            >
              {{ '&nbsp;- ' + profile.residency }}
            </div>
            <div *ngIf="onlyResidency && isBigScreen" [ngClass]="{ 'tiny-specialty2': tinyMode, type: !tinyMode }">
              {{ profile.residency }}
            </div>
          </div>

          <mat-label
            *ngIf="profile.isGarde && !hidePosition"
            [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty2': tinyMode, type: !tinyMode }"
          >
            &nbsp;de garde
          </mat-label>
        </div>
        <mat-label
          *ngIf="
            alignSpecialty &&
            !hideSpecialty &&
            isSmartPlanningDesign &&
            !isStatopView &&
            !isIbodeView &&
            !isMyProgramView
          "
          [ngClass]="{ 'type-sidenav': isSideNav, 'tiny-specialty2': tinyMode, type: !tinyMode }"
        >
          - {{ specialty?.name }}</mat-label
        >
      </div>

      <!-- --------------------------------------------------- Content Biss ------------------------------------------------------>

      <div
        *ngIf="
          profile.specialties &&
          allSpecialtiesOfRightType &&
          !isSmartPlanningDesign &&
          !hideSpecialty &&
          !isAnnuaire &&
          profile.position == 'Chirurgien'
        "
        [class.text-center]="isColumn"
        class="width-100"
      >
        <div>
          <app-specialties-hover
            [showHover]="false"
            [ngClass]="
              !programRecap && !tinyMode && !isStatopView && !isIbodeView
                ? 'specialties-hover'
                : !tinyMode
                  ? 'specialties-hover-program-recap'
                  : 'specialties-hover-tiny-mode'
            "
            [profile]="profile"
            [isStatopView]="isStatopView"
            [tinyMode]="tinyMode"
          ></app-specialties-hover>
        </div>
      </div>

      <!-- --------------------------------------------------- Hospital Name ------------------------------------------------------>

      <div
        *ngIf="isMultiHospital && !hideHospital && profile.hospitals && !isAccountView && !isSmartPlanningDesign"
        [class.text-center]="isColumn"
        class="width-100"
      >
        <div
          [ngClass]="
            profile.position == 'Chirurgien' && !hideSpecialty && !isAnnuaire
              ? 'hospital-with-specialties'
              : 'hospital-without-specialties'
          "
        >
          <app-hospitals-hover
            [showHover]="false"
            [isNight]="nightMode"
            [ngClass]="[
              profile.position == 'Chirurgien' && !hideSpecialty && !isAnnuaire
                ? 'hospitals-hover-with-specialties'
                : hideSpecialty || (hideSpecialty && isAnnuaire)
                  ? 'hospitals-hover-without-specialties'
                  : hideSpecialty && hidePosition
                    ? 'hospitals-hover-without-specialties-without-position'
                    : 'hospitals-hover-without-specialties',
            ]"
            [ngStyle]="{ top: '48px' }"
            [profile]="profile"
          ></app-hospitals-hover>
        </div>
      </div>

      <!-- --------------------------------------------------- Role Selector ------------------------------------------------------>

      <div
        *ngIf="canEditRoles && isProfileInNurses && programRecap && !isHome && !isMyProgramView"
        style="margin-left: -37px"
      >
        <div class="mini-default-select role-selector">
          <div class="select-container">
            <select
              [(ngModel)]="role"
              [compareWith]="compareRole"
              (ngModelChange)="onRoleChange($event)"
              style="background: #eef8fd; font-weight: 500"
            >
              <option *ngFor="let role_ of availableRoles" [ngValue]="role_">{{ role_.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div *ngIf="isProfileInNurses && ((programRecap && isHome && role) || (!canEditRoles && role && programRecap))">
        <div class="roleHome">
          {{ role.name }}
        </div>
      </div>

      <div *ngIf="isProfileInIades && programRecap && role">
        <div class="roleHome">
          {{ role.name }}
        </div>
      </div>

      <div *ngIf="(isProfileInNurses || isProfileInIades) && !programRecap && !isHome && role && !isMyProgramView">
        <div style="font-size: smaller">({{ role.name }})</div>
      </div>
    </div>
  </div>
  <div
    *ngIf="showImage && isPictureRight"
    fxLayout="row"
    [ngClass]="{ 'image-container': viewFlex && avatarBoxColor !== 'secondary' }"
  >
    <img
      (error)="onAvatarError()"
      [src]="picture"
      alt="avatar"
      [ngClass]="{
        image: !viewFlex,
        'small-avatar': smallAvatar,
        'tiny-avatar': tinyMode,
        bigImage: viewFlex,
        'big-row-image': isBigRow,
        'secondary-border': avatarBoxColor === 'secondary',
        'image-sidenav': isSideNav,
        'image-margin-left': isPictureRight,
      }"
    />
  </div>

  <!-- --------------------------------------------------- Profile if profile is missing ------------------------------------------------------>

  <div *ngIf="!profile && !isSurgeonSelection" [fxLayoutAlign]="fxLayoutAlign" [fxLayout]="displayMode">
    <div [ngClass]="{ 'image-container': viewFlex && avatarBoxColor !== 'secondary' }">
      <img
        (error)="onAvatarError()"
        [ngClass]="{
          image: !viewFlex,
          bigImage: viewFlex,
          'big-row-image': isBigRow,
          'secondary-border': avatarBoxColor === 'secondary',
        }"
        alt="avatar"
        src="assets/icons/specialties/urgences.svg"
      />
    </div>
    <div
      [class.big-row]="isBigRow"
      [class.no-margin-left]="isColumn"
      [fxLayoutAlign]="isColumn ? 'start center' : 'start start'"
      class="profile-name"
      fxFlex
      fxLayout="column"
    >
      <div [fxLayoutAlign]="fxLayoutAlign" [fxLayout]="displayMode">
        <mat-label [class.name-flex]="viewFlex" [class.text-center]="isColumn" [class.text-start]="!isColumn">
          Urgences
        </mat-label>
      </div>
    </div>
  </div>

  <div *ngIf="isSurgeonSelection" [fxLayoutAlign]="fxLayoutAlign" [fxLayout]="displayMode">
    <div>
      <img (error)="onAvatarError()" [src]="picture" alt="avatar" class="image" />
    </div>
    <div fxLayoutAlign="start start" class="profile-name" fxFlex fxLayout="column">
      <div [fxLayoutAlign]="fxLayoutAlign" [fxLayout]="displayMode">
        <mat-label class="text-start small-text"
          >Sélectionner {{ hospitalNames.surgeonsNameGenreMasculin ? 'un' : 'une' }}
          {{ hospitalNames.surgeonsName }}</mat-label
        >
      </div>
    </div>
  </div>
</div>
